import * as moment from 'moment';
import 'moment/locale/pt-br';

export function getDataAtual() {
	return moment().format('YYYY/MM/DD HH:mm:ss');

}

export function getData(data) {
	return new Date(data);
}

export function getDataHoraFormatada(
	data,
	formato = 'DD/MM/YYYY HH:mm:ss'
) {
	if (!data) {
		return '';
	}

	const texto = data.toString();
	const somenteData = !/[Hhms]/.test(formato);

	if (somenteData && /^\d{4}-\d{2}-\d{2}/.test(texto)) {
		return moment(
			texto.substring(0, 10),
			'YYYY-MM-DD'
		).format(formato);
	}

	return moment(data).format(formato);
}

export function getDataBanco(data) {
	
	if (data) {
		return `${data.split('/')[2]}/${data.split('/')[1]}/${data.split('/')[0]}`;
	} else {
		return null;
	}
}

export function getDataHoraBanco(dataHora) {

	if (dataHora) {
		let data = `${dataHora.split(' ')[0].split('/')[2]}/${dataHora.split(' ')[0].split('/')[1]}/${dataHora.split(' ')[0].split('/')[0]}`;
		let hora = dataHora.split(' ')[1];

		return `${data} ${hora}`;
	} else {
		return null;
	}
}
